import $ from 'jquery';

window.$ = $;

const slots = () => {
  $(() => {
    if ($('#js_answers_slots').length === 0) {
      return;
    }

    $('input.js_check_all_slots_on_date').each(function (index) {
      const groupId = $(this).data('slots-group-id');
      const checkAll = $(this);
      const checkboxes = $(`input[data-slots-group-id="${groupId}"]:not(.js_check_all_slots_on_date)`);

      checkAll.on('ifChecked ifUnchecked', (event) => {
        if (event.type == 'ifChecked') {
          checkboxes.iCheck('check');
        } else {
          checkboxes.iCheck('uncheck');
        }
      });

      var updateCheckAll = function(event){
        if(checkboxes.filter(':checked').length == checkboxes.length) {
          checkAll.prop('checked', true);
        } else {
          checkAll.prop('checked', false);
        }
        checkAll.iCheck('update');
      };

      checkboxes.on('ifChanged', updateCheckAll);
      updateCheckAll();
    });

  });
};

export default slots;
